import {
  Center,
  type CenterProps,
} from '@ironhack/design-system2/components/center';
import { Icon } from '@ironhack/design-system2/components/icon';
import dynamic from 'next/dynamic';
import { type FunctionComponent, type ReactElement } from 'react';
import { useMeasure } from 'react-use';

type Props = { icon?: FunctionComponent } & CenterProps;

const Confetti = dynamic(() => import('react-confetti'), { ssr: false });

const drawConfettiShape = (ctx: CanvasRenderingContext2D): void => {
  const w = 5;
  const h = 15;
  ctx.beginPath();
  ctx.fillRect(-w / 2, -h / 2, w, h);
  ctx.closePath();
  ctx.restore();
};

export const ConfettiBox = (props: Props): ReactElement => {
  const { icon, ...centerProps } = props;

  const [
    confettiBoxRef,
    {
      width: confettiWidth,
      height: confettiHeight,
      top: confettiTop,
      left: confettiLeft,
    },
  ] = useMeasure<HTMLDivElement>();

  return (
    <Center position="relative" ref={confettiBoxRef} w="full" {...centerProps}>
      <Confetti
        drawShape={drawConfettiShape}
        height={confettiHeight}
        numberOfPieces={40}
        style={{
          position: 'absolute',
          top: confettiTop,
          left: confettiLeft,
          zIndex: 1,
        }}
        width={confettiWidth}
      />
      {icon && (
        <Center bg="fill.primary" borderRadius="full" boxSize="56px" zIndex={2}>
          <Icon as={icon} boxSize="24px" color="stroke.white" />
        </Center>
      )}
    </Center>
  );
};
